import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import StandardModalContent from '../StandardModalContent/StandardModalContent.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { deepEqual, newInstance } from 'Helper/deepEqual'
import { bindActionCreators, compose } from 'redux'
import rootActions from 'actions/rootActions'
import { connect } from 'react-redux'
import DivButton from '../DivButton/DivButton.jsx'
import SearchList from 'GeneralUI/SearchList/SearchList.jsx'
import NoteHistoryButton from 'GeneralUI/NoteHistory/NoteHistoryButton.jsx'
import NoteHistory from 'GeneralUI/NoteHistory/NoteHistory.jsx'
import _ from 'lodash'

const HotTextUseDialog = ({
  noteHistory = [],
  onShowHistory=() => null,
  autoSelect,
  onChange,
  type,
  readOnly,
  hotTextItems,
  disabled,
  value,
  'data-toggle': dataToggle,
  'data-title': dataTitle,
  'data-placement': dataPlacement
}) => {
  const textInput = useRef()

  const initValue = value || ''
  const initStartPosition = autoSelect ? 0 : initValue.length

  const [showButtons, setShowButtons] = useState(true)
  const [tempValue, setTempValue] = useState(initValue)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [caretPosition, setCaretPosition] = useState(initStartPosition)

  useEffect(() => {
    textInput.current.focus()
    textInput.current.setSelectionRange(
      caretPosition,
      isFirstRender ? tempValue.length : caretPosition
    )
    setIsFirstRender(false)
  }, [caretPosition])

  const addText = text => {
    const textInputElement = textInput.current
    const start = textInputElement.selectionStart
    const end = textInputElement.selectionEnd
    const length = end - start
    const newTempValue = tempValue
    const hotText = text.trim()

    if (hotText !== '') {
      const leading =
        start > 0 && newTempValue.substr(start - 1, 1) > ' ' ? ' ' : ''
      const trailing =
        start + length < newTempValue.length &&
        newTempValue.substr(start + length, 1) !== ' '
          ? ' '
          : ''

      const textToAdd = leading + hotText + trailing

      const newValue =
        newTempValue.slice(0, start) + textToAdd + newTempValue.slice(end)

      const caretPosition = start + textToAdd.length
      setTempValue(newValue)
      onChange(newValue)
      setCaretPosition(caretPosition)
    }
  }

  const hotTextButton = (text, i) => {
    return (
      <DivButton
        className="btn btn-default hot-text-button"
        onClick={() => {
          addText(text)
        }}
        key={'hot-text-' + i}
        disabled={disabled}
        data-toggle={dataToggle}
        data-title={dataTitle}
        data-placement={dataPlacement}
      >
        {text}
      </DivButton>
    )
  }

  const searchList = () => {
    const itemList = hotTextItems.map((item, i) => {
      return { name: item.value }
    })
    return (
      <SearchList
        columns={[{ header: 'Text', id: 'name' }]}
        data={itemList}
        clickHandler={item => {
          if (item) {
            addText(item.name)
          }
        }}
        style={{
          position: 'relative',
          fontSize: '14px',
          height: '200px',
          padding: '5px 10px 10px 10px'
        }}
        placeholder="Search hot text"
        alwaysShowList={true}
        clearOnSelect={true}
      />
    )
  }

  //
  //
  // TODO: test readonly case
  //
  //
  if (readOnly) {
    return (
      <div className={'hot-text-dialog'} style={{ width: '80%' }}>
        {type === 'area' ? (
          <textarea
            ref={textInput}
            className="hot-text-input"
            autoFocus
            aria-label={'temporary hot text input'}
            rows="6"
            value={tempValue || ''}
            disabled={true}
          />
        ) : (
          <input
            ref={textInput}
            type={type || 'text'}
            className="hot-text-input"
            autoFocus
            aria-label={'temporary hot text input'}
            size={tempValue != null ? tempValue.toString().length : 1}
            value={tempValue || ''}
            disabled={true}
          />
        )}
        <NoteHistoryButton noteHistory={noteHistory} handler={onShowHistory}/>
      </div>
    )
  } else {
    const buttons = hotTextItems.map((item, i) => {
      return hotTextButton(item.value, i)
    })

    const buttonRows = []
    const numCols = 3
    const numRows = Math.floor(buttons.length / numCols) + 1
    for (let i = 0; i < numRows; i++) {
      buttonRows[i] = (
        <div className="hot-text-button-grid" key={'hot-text-button-row' + i}>
          {buttons.slice(i * numCols, (i + 1) * numCols)}
        </div>
      )
    }
    return (
      <div className={'hot-text-dialog'}>
        <div
          data-toggle={dataToggle}
          data-title={dataTitle}
          data-placement="bottom"
        >
          {type === 'area' ? (
            <textarea
              ref={textInput}
              className="hot-text-input"
              autoFocus
              aria-label={'temporary hot text input'}
              rows="6"
              onChange={e => {
                setTempValue(e.target.value)
                onChange(e.target.value)
              }}
              value={tempValue || ''}
              disabled={disabled}
            />
          ) : (
            <input
              ref={textInput}
              type={type || 'text'}
              className="hot-text-input"
              autoFocus
              aria-label={'temporary hot text input'}
              size={tempValue != null ? tempValue.toString().length : 1}
              onChange={e => {
                setTempValue(e.target.value)
                onChange(e.target.value)
              }}
              value={tempValue || ''}
              disabled={disabled}
            />
          )}
        </div>
        <div className={'choser-container'}>
          <NoteHistoryButton noteHistory={noteHistory} handler={onShowHistory}/>
          <div className={'list-header'}>
            <div className={'header-text'}>Hot text choices:</div>
            <div className="right-side">
              <div
                className={'btn btn-default'}
                onClick={() => setShowButtons(false)}
              >
                <FontAwesomeIcon icon={['fas', 'bars']} />
              </div>
              <div
                className={'btn btn-default'}
                onClick={() => setShowButtons(true)}
              >
                <FontAwesomeIcon icon={['fas', 'grid']} />
              </div>
            </div>
          </div>
          <div>
            {buttonRows.length === 0 ? (
              'No hot text defined yet.'
            ) : showButtons ? (
              <div className="button-grid-container">{buttonRows}</div>
            ) : (
              searchList()
            )}
          </div>
        </div>
      </div>
    )
  }
}

const HotTextEditDialog = ({
  type,
  allHotTextItems,
  onHotTextChange,
  onAddItem
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [allHotTextItems]);

  const editHotTextInput = (text, i) => {
    return (
      <input
        type={type || 'text'}
        className="hot-text-input"
        aria-label={`edit hot text input ${i}`}
        width="100%"
        key={'hot-text-input-' + i}
        onChange={e => {
          onHotTextChange(e.target.value, i)
        }}
        value={allHotTextItems[i].value || ''}
      />
    )
  }

  const inputs = allHotTextItems.map((item, i) => {
    return (
      <div key={'hot-text-edit-div-' + i} style={{ width: '100%' }}>
        {editHotTextInput(item.value, i)}
      </div>
    )
  })

  return (
    <div className={'hot-text-dialog'}>
      <div className={'button-grid-container'}>
        <div style={{ marginTop: '10px', fontSize: '18px' }}>
          Hot text items:
        </div>
        <hr />

        <div className={'inputs-container'} ref={containerRef}>{inputs}</div>

        <div style={{ marginBottom: '20px' }}>
          <div
            className="btn btn-default"
            onClick={onAddItem}
            key={'add-new-item'}
          >
            Add new item
          </div>
        </div>
      </div>
    </div>
  )
}

const HotTextDialog = ({
  noteHistory = [],
  canEditHotText = true,
  onChangeValue = () => {},
  hotTextName = '',
  cancelHandler = () => {},
  autoSelect = false,
  required = false,
  initialMode,
  value,
  onChange,
  type,
  readOnly,
  setFinalValue,
  disabled,
  xtractAPI,
  closeSelf,
  'data-toggle': dataToggle,
  'data-title': dataTitle,
  'data-placement': dataPlacement
}) => {
  const [valueState, setValueState] = useState(value)
  const [allHotTextItems, setAllHotTextItems] = useState(null)
  const [mode, setMode] = useState(initialMode || 'use')
  const [savingItems, setSavingItems] = useState(false)
  const [tempAllHotTextItems, setTempAllHotTextItems] = useState([])

  useEffect(() => {
    let mode = initialMode || 'use'
    if (readOnly && !initialMode) {
      mode = 'readOnly'
    }
    if (!readOnly) {
      getHotTextItems()
    }

    setMode(mode)
  }, [])

  const onModeChange = value => {
    setMode(value)
  }
  const onHotTextChange = (value, i) => {
    const tempAllHotItems = tempAllHotTextItems
    tempAllHotItems[i].value = value
    setTempAllHotTextItems(newInstance(tempAllHotItems))
  }
  const onAddItem = () => {
    const tempAllHotItems = tempAllHotTextItems

    // find the largest index

    const largestIndex =
      tempAllHotItems.length === 0
        ? 0
        : tempAllHotItems
            .map(item => {
              return parseInt(item.name.replace(/[^\d]*/, ''))
            })
            .sort(function (a, b) {
              return b - a
            })[0] // sort descending // get first (largest) one

    tempAllHotItems.push({
      app: 'XPS',
      section: 'hot_text',
      name: hotTextName + (largestIndex + 1),
      value: '',
      config_id: -largestIndex // a unique, temporary ID
    })

    setTempAllHotTextItems(newInstance(tempAllHotItems))
  }

  function sortArrayWithNumbers(arr) {
    // Regular expression to extract the number at the end of each string
    const regex = /(\d+)$/

    // Custom comparison function
    const compareStrings = (a, b) => {
      const numA = parseInt(a.name.match(regex)[1])
      const numB = parseInt(b.name.match(regex)[1])

      // Compare the extracted numbers
      if (numA < numB) {
        return -1
      } else if (numA > numB) {
        return 1
      } else {
        // If the numbers are equal, use natural string comparison
        const strA = a.name.replace(regex, '')
        const strB = b.name.replace(regex, '')
        return strA.localeCompare(strB)
      }
    }

    // Sort the array using the custom comparison function
    arr.sort(compareStrings)

    return arr
  }

  const getHotTextItems = () => {
    xtractAPI(
      'config',
      'search',
      {
        and: [
          { equal: { section: 'hot_text' } },
          { like: { name: hotTextName + '%' } }
        ]
      },
      {
        200: response => {
          const hotTextItems = response.data.data.config

          const validItems = sortArrayWithNumbers(
            hotTextItems.filter(item => {
              return !isNaN(parseInt(item.name.replace(/[^\d]*/, '')))
            })
          )

          setSavingItems(false)
          setAllHotTextItems(newInstance(validItems))
          setTempAllHotTextItems(newInstance(validItems))
        }
      }
    )
  }
  const asyncForEach = async (array, callback) => {
    if (Array.isArray(array)) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }
  }

  const saveHotTextItems = async () => {
    setSavingItems(true)

    const handleOneItem = (item, i, resolve, reject) => {
      if (!deepEqual(item, allHotTextItems[i])) {
        if (item.config_id > 0) {
          if (item.value === '') {
            xtractAPI('config/' + item.config_id, 'delete', null, {
              200: response => {
                resolve()
              },
              400: (response, action, defaultCallback) => {
                defaultCallback(response, action)
                reject()
              }
            })
          } else {
            xtractAPI('config/' + item.config_id, 'update', item, {
              200: response => {
                resolve()
              },
              400: (response, action, defaultCallback) => {
                defaultCallback(response, action)
                reject()
              }
            })
          }
        } else {
          if (item.value !== '') {
            xtractAPI('config', 'create', item, {
              200: response => {
                // we've just added an element: get its real ID from the response
                // and put it in our local data

                const newTempAllHotTextItems = tempAllHotTextItems.slice()
                const configId = response.data.data.config.config_id
                const index = newTempAllHotTextItems.findIndex(itm => {
                  return itm.config_id === item.config_id
                })

                if (index >= 0) {
                  newTempAllHotTextItems[index].config_id = configId
                }

                setTempAllHotTextItems(newTempAllHotTextItems)
                setAllHotTextItems(newInstance(newTempAllHotTextItems))
                resolve()
              },
              400: (response, action, defaultCallback) => {
                defaultCallback(response, action)
                reject()
              }
            })
          } else {
            resolve()
          }
        }
      } else {
        resolve()
      }
    }

    // separate hot text items into the ones that existed and the ones being newly added
    const originalItems = []
    const newItems = []
    tempAllHotTextItems.forEach(item => {
      if(item.config_id > 0) {
          originalItems.push(item)
      } else {
        newItems.push(item)
      }
    })
    // look for dups in original items
    originalItems.forEach(item => {
      const dups = originalItems.filter(oi => oi.value === item.value)
      if(dups.length > 1) {
        // we have multiple original items with the same value. This means either we already
        // had dups from before or an original item was changed in a way that made it a dup.
        // we will set these to blank so they get removed later. 
        dups.filter(d => d.config_id !== item.config_id).forEach(dup => dup.value = "")
      }
    })

    // these cleaned original items can now be added tot he group of final items to process
    const finalHotText = originalItems

    // now that final items has unique values (possibly with "" dups) we can search the
    // new items and filter out any items that already exist in the original items and push them.
    newItems.forEach(item => {

      // Trim spaces from the current item value
      const trimmedItemValue = item.value.trim();

      // Map the finalHotText values to their trimmed versions
      const finalHotTextValues = finalHotText.map(oi => oi.value.trim());

      // Check if the trimmed item value already exists
      if (finalHotTextValues.indexOf(trimmedItemValue) === -1) {
        finalHotText.push(item);
      }
    })

    await asyncForEach(finalHotText, async (item, i) => {
      await new Promise((resolve, reject) => {
        handleOneItem(item, i, resolve, reject)
      }).then(
        result => {},
        error => {}
      )
    })
    setSavingItems(false)
    getHotTextItems()
  }
  const loading = message => {
    const style = {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: '1 1 auto'
    }
    return (
      <div>
        <div style={{ marginBottom: '20px' }}>{message}</div>

        <div className="window-loading" style={style}>
          <FontAwesomeIcon
            icon={['fas', 'circle-notch']}
            spin
            size="3x"
            fixedWidth
          />
        </div>
      </div>
    )
  }

  if (!allHotTextItems && mode !== 'readOnly' && mode !== 'history') {
    return loading('Reading hot text labels...')
  }
  if (savingItems) {
    return loading('Saving hot text labels...')
  }
  if (mode === 'history') {
    return <NoteHistory noteHistory={noteHistory} returnHandler={() => setMode('use')}/>
  } else if(mode === 'edit') {
    return (
      <StandardModalContent
        messageContent={
          <HotTextEditDialog
            allHotTextItems={tempAllHotTextItems}
            onHotTextChange={onHotTextChange}
            onAddItem={onAddItem}
          />
        }
        okHandler={() => {
          saveHotTextItems()
          setMode('use')
          return true
        }}
        okText={'Save'}
        cancelHandler={() => {
          setTempAllHotTextItems(newInstance(allHotTextItems))
          setMode('use')
          return true
        }}
        cancelText={'Cancel'}
        closeSelf={closeSelf}
      />
    )
  } else if (mode === 'readOnly') {
    return (
      <StandardModalContent
        messageContent={
          <HotTextUseDialog
            readOnly={true}
            value={value}
            type={type}
            noteHistory={noteHistory}
            onShowHistory={() => setMode('history')}
          />
        }
        okHandler={() => null}
        okText={'OK'}
        closeSelf={closeSelf}
      />
    )
  } else {
    const nonEmptyItems = allHotTextItems.filter(item => {
      return item.value !== undefined
    })

    const dontHaveRequiredValue = required && !valueState

    return (
      <StandardModalContent
        messageContent={
          <HotTextUseDialog
            onShowHistory={() => setMode('history')}
            noteHistory={noteHistory}
            value={valueState}
            hotTextItems={nonEmptyItems}
            onModeChange={onModeChange}
            onChange={value => {
              setValueState(value.trim())
              onChange(value)
            }}
            type={type}
            autoSelect={autoSelect}
            canEditHotText={canEditHotText}
            disabled={disabled}
            data-toggle={dataToggle}
            data-title={dataTitle}
            data-placement={dataPlacement}
          />
        }
        thirdHandler={() => {
          return setFinalValue(valueState)
        }}
        thirdText={'OK'}
        thirdDisabled={disabled || dontHaveRequiredValue}
        okHandler={() => {
          cancelHandler()
          return null
        }}
        okClassName={'btn-danger'}
        okText={'Cancel'}
        cancelHandler={() => {
          onModeChange('edit')
          return true
        }}
        cancelDisabled={!canEditHotText}
        cancelClassName={'btn-info'}
        cancelText={'Edit Hot Text'}
        data-toggle={dontHaveRequiredValue ? 'tooltip' : dataToggle}
        data-title={
          dontHaveRequiredValue ? 'You must enter a value' : dataTitle
        }
        data-placement={dataPlacement}
        closeSelf={closeSelf}
      />
    )
  }
}

HotTextDialog.propTypes = {
  // optional note history
  noteHistory: PropTypes.array,
  // root name of hot text strings in config table
  hotTextName: PropTypes.string,
  // can the use edit hot text definitions?
  canEditHotText: PropTypes.bool,
  // should the text be selected upon entry?
  autoSelect: PropTypes.bool,
  // optionally open in a specific mode (e.g. 'history')
  initialMode: PropTypes.string,
  // callback when value changes due to hot text dialog being shown
  onChangeValue: PropTypes.func,
  // callback when cancel is chosen
  cancelHandler: PropTypes.func,
  // callback when value changes due to hot text dialog being shown
  setFinalValue: function (props, propName, componentName) {
    if (
      !props['readOnly'] &&
      (props[propName] === undefined || typeof props[propName] != 'function')
    ) {
      return new Error('Please provide a setFinalValue function')
    }
  },
  // to display a read-only note
  readOnly: PropTypes.bool,
  // don't allow an empty result
  required: PropTypes.bool
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(rootActions, dispatch)
}

const mapStateToProps = state => {
  return {
    appConfig: state.appConfig
  }
}

const enhance = compose(connect(mapStateToProps, mapDispatchToProps))

export default enhance(HotTextDialog)
